import { IoArrowBack } from "react-icons/io5";

import { IAdvisorChoice } from "@types";

import { AdvisorButton } from "./AdvisorButton";

/**
 * The choice chips for the latest turn, plus a lighter-weight "back" link if one was offered.
 *
 * Every chip looks the same. The backend marks one choice `recommended`, but the panel
 * deliberately doesn't render that — the advisor shouldn't steer the user's pick by
 * highlighting an option before they've read the rest.
 */
export function AdvisorChoices({
  choices,
  onSelect,
}: {
  choices: IAdvisorChoice[];
  onSelect: (choice: IAdvisorChoice) => void;
}) {
  const forward = choices.filter(choice => choice.choice_id !== "BACK");
  const back = choices.find(choice => choice.choice_id === "BACK");

  return (
    <div
      role="group"
      aria-label="Suggested replies"
      className="mt-4 flex flex-col items-start gap-2"
    >
      {forward.map(choice => (
        <AdvisorButton
          key={choice.choice_id}
          onClick={() => onSelect(choice)}
          className="whitespace-normal text-left leading-snug"
        >
          {choice.label}
        </AdvisorButton>
      ))}
      {back && (
        // Back is a real server-side transition, not browser history — but it's a step
        // backwards, so it reads as secondary.
        <AdvisorButton
          variant="ghost"
          size="sm"
          onClick={() => onSelect(back)}
          className="mt-1"
        >
          <IoArrowBack className="h-3.5 w-3.5" />
          {back.label}
        </AdvisorButton>
      )}
    </div>
  );
}
